/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Carousel from 'react-material-ui-carousel';
import consultaApi from '../../../services/consultaApi';

const useStyles = makeStyles(theme => ({
    controlaPaper: {
        margin: '30px 0px 30px 0px'
    }
}))

function Conteudo(props) {
    return (
        <Typography>
            {props.item.valor}
        </Typography>
    )
}

export default function InfoHome(props) {

    const classes = useStyles();

    const [informacoes, setInformacoes] = useState([]);

    async function consultaBanco() {
        let procedure = {
            PROCNAME: 'WEBSITE_BUSCA_MSG',
        }

        const resposta = await consultaApi(procedure);

        let respostaDados = resposta.data.DATASET;

        if (respostaDados) {
            return respostaDados;
        }
    }

    async function pesquisar() {
        let retornoFunction = await consultaBanco();
        setInformacoes(retornoFunction);
    }

    useEffect(() => {
        pesquisar();
    }, []);

    var items = informacoes && informacoes.map(informacao => ({ valor: informacao.MSG }))


    return (
        <Grid item xs={12}>
            {items &&
                <Card className={classes.controlaPaper}>
                    <CardContent>
                        <Carousel navButtonsAlwaysInvisible animation="slide">
                            {items.map((item, i) => <Conteudo key={i} item={item} />)}
                        </Carousel>
                    </CardContent>
                    <CardActions>
                        <Button
                            size="small"
                            color="primary"
                            disabled
                        >
                            Saiba Mais
                    </Button>
                    </CardActions>
                </Card>
            }
        </Grid>
    )
}